/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Stack, Typography } from "@mui/material";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird";
import Container from "@/src/components/Container/Container";
import Grid from "@mui/material/Grid";
import { CarouselProvider } from "@/src/components/Carousel/CarouselProvider";
import { CarouselSlides } from "@/src/components/Carousel/CarouselSlides";
import { CarouselSlide } from "@/src/components/Carousel/CarouselSlide";
import { customerFeedbackReviews } from "@/src/components/Sections/Generic/CustomerFeedback/customerFeedbackReviews";
import { customerFeedbackStyle } from "@/src/components/Sections/Generic/CustomerFeedback/customerFeedbackStyle";
import { CarouselArrow } from "@/src/components/Carousel/CarouselArrow";
import ProvenExpertSealStandard from "@/src/components/Provenexpert/ProvenExpertSealStandard";
import ProvenExpertSealGold from "@/src/components/Provenexpert/ProvenExpertSealGold";
import IconButtonLegalbird from "@/src/components/legalbird/IconButtonLegalbird/IconButtonLegalbird";
import { InfoOutlined } from "@mui/icons-material";
import { useState } from "react";
import DialogModal from "@/src/components/DialogModal/DialogModal";
import Section from "@/src/components/Section/Section";

export default function CustomerFeedback() {
  const [showHintDialog, setShowHintDialog] = useState(false);

  return (
    <Section>
      <CarouselProvider loop>
        <Container variant={"lg"} showPaddingBlock={false}>
          <Grid container sx={{ marginBottom: "3rem" }}>
            <Grid size={{ md: 8 }}>
              <ChipLegalbird label={"Kundenfeedback"} sx={{ marginBottom: "1rem" }} />
              <Typography variant={"h3"} component={"h2"}>
                Eindrücke unserer Mandantinnen und Mandanten der letzten Jahre
                <IconButtonLegalbird
                  label={"Hinweistext anzeigen"}
                  variant={"text"}
                  onClick={() => setShowHintDialog(true)}
                  sx={{
                    marginLeft: "0.5rem",
                  }}
                >
                  <InfoOutlined />
                </IconButtonLegalbird>
              </Typography>
            </Grid>
            <Grid size={{ md: 4 }}>
              <Stack direction={"row"} spacing={2} sx={customerFeedbackStyle.sliderArrowsDesktop}>
                <CarouselArrow type={"previous"} />
                <CarouselArrow type={"next"} />
              </Stack>
            </Grid>
          </Grid>
        </Container>
        <CarouselSlides>
          {customerFeedbackReviews.map((review, idx) => (
            <CarouselSlide key={idx} sx={customerFeedbackStyle.slide}>
              <Box sx={customerFeedbackStyle.slideInner}>
                <Typography component={"blockquote"}>“{review}”</Typography>
              </Box>
            </CarouselSlide>
          ))}
        </CarouselSlides>
        <Stack direction={"row"} spacing={2} sx={customerFeedbackStyle.sliderArrowsMobile}>
          <CarouselArrow type={"previous"} />
          <CarouselArrow type={"next"} />
        </Stack>
        <Container variant={"lg"} showPaddingBlock={false}>
          <Stack sx={{ justifyContent: "center", marginTop: "8rem" }} direction={"row"} spacing={4}>
            <ProvenExpertSealStandard sx={customerFeedbackStyle.seals} />
            <ProvenExpertSealGold sx={customerFeedbackStyle.seals} />
          </Stack>
        </Container>
      </CarouselProvider>
      <DialogModal maxWidth={"md"} open={showHintDialog} title={"Informationen zur Echtheit der Bewertungen"} onClose={() => setShowHintDialog(false)}>
        <Typography>
          Uns ist Transparenz wichtig – gerade als Kanzlei. Alle auf dieser Webseite dargestellten Mandantenstimmen sind echte, verifizierte Rückmeldungen, die
          im Rahmen unserer internen Mandantenbefragungen nach Abschluss des jeweiligen Verfahrens erhoben wurden. Zum Schutz der Privatsphäre unserer
          Mandanten, zur Einhaltung der DSGVO und zur Wahrung der anwaltlichen Schweigepflicht veröffentlichen wir diese Rückmeldungen in anonymisierter Form
          ohne Nennung von Personenbezug. Jede dieser Bewertungen wurde vor der Veröffentlichung manuell durch uns auf ihre Echtheit geprüft und ist intern
          einem realen, erfolgreich abgeschlossenen Mandat zugeordnet.
        </Typography>
      </DialogModal>
    </Section>
  );
}
